import {Environment} from "./environment.model";

export const environment: Environment = {
  production: false,

  //applicationBaseUrl: 'http://localhost:4200',
  applicationBaseUrl: 'https://planning-tools-admin-integration.viessmann-climatesolutions.com',

  auth: {
    appId: 'planning-tools-admin',
    baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
    usersUrl: 'https://api-integration.viessmann-climatesolutions.com/users/v1/users/me'
  },

  header: {
    baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
    accountAppUrl: 'https://account-integration.viessmann-climatesolutions.com'
  },

  backend: {
    //baseUrl: "http://127.0.0.1:8080",
    baseUrl: "https://api-integration.viessmann-climatesolutions.com/planning-core/planning-tools-admin",
  }
};
